exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntextarea.form-control {\n\t/* PIRS2018-1846 */\n\tresize: both;\n\tmargin: 0 !important;\n}\n.resize-polyfill-polyfilled textarea {\n\theight: 100% !important;\n}\n", ""]);
